import { Button, Card, Stack } from '@mui/material'
import '../../Style/Footer.css'
import communityLogo from '../../Icons/logo.png'
import BPPLogo from '../../Icons/BPP_logo.png'
import { useNavigate } from 'react-router-dom'
import { DarkMode, LightMode } from '@mui/icons-material'

const Footer = ({ dark, setDark }) => {
  const navigate = useNavigate()

  return (
    <Card raised sx={{ m: {md: 2, xs: 1}, mt: '0 !important', mb: { md: 4, xs: 1 } }}>
      <Card className='footer' sx={{ p: 1, pb: 2 }}>
        <img
          alt='logo'
          src={communityLogo}
          style={{
            maxWidth: '100%',
            objectFit: 'contain',
            height: '60px',
            margin: 'auto',
            marginBottom: '16px',
            borderRadius: '4px'
          }}
        />
        <Stack
          direction='row'
          sx={{
            justifyContent: 'space-between',
            width: '90%',
            m: 'auto',
            flexWrap: 'wrap',
            gap: 6
          }}
        >
          <Stack>
            <span className='footerLinkHeader'>Support</span>
            <span
              tabIndex='0'
              className='footerLinks'
              onClick={() => navigate('/support/help')}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  navigate('/support/help')
                }
              }}
            >
              Help
            </span>
            <span
              tabIndex='0'
              className='footerLinks'
              onClick={() => navigate('/support/adminhelp')}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  navigate('/support/adminhelp')
                }
              }}
            >
              Upload Help
            </span>
            <span
              tabIndex='0'
              className='footerLinks'
              onClick={() => navigate('/support/contact')}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  navigate('/support/contact')
                }
              }}
            >
              Contact Us
            </span>
          </Stack>
          <Stack>
            <span className='footerLinkHeader'>Company</span>
            <span
              tabIndex='0'
              className='footerLinks'
              onClick={() => navigate('/support/about')}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  navigate('/support/about')
                }
              }}
            >
              About
            </span>
          </Stack>
          <Stack>
            <span className='footerLinkHeader'>Terms & Privacy</span>
            <span
              tabIndex='0'
              className='footerLinks'
              onClick={() => navigate('/support/termsofuse')}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  navigate('/support/termsofuse')
                }
              }}
            >
              Terms of Use
            </span>
            <span
              tabIndex='0'
              className='footerLinks'
              onClick={() => navigate('/support/privacy')}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  navigate('/support/privacy')
                }
              }}
            >
              Privacy
            </span>
          </Stack>

          <Stack>
            <Stack
              direction={'row'}
              onClick={() => window.open('https://www.bluepointplanning.com/')}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
                cursor: 'pointer', 
                marginBottom: 2
              }}
            >
              <b>Sponsored by</b>
              <img
                alt='logo'
                src={BPPLogo}
                style={{
                  maxWidth: '100%',
                  objectFit: 'contain',
                  height: '80px',
                  borderRadius: '4px'
                }}
              />
            </Stack>
            <Button
              onClick={() => {
                window.sessionStorage.setItem('theme', !dark ? '0' : '1')
                setDark(!dark)
              }}
              color='inherit'
              startIcon={dark ? <DarkMode /> : <LightMode />}
              sx={{ height: 'fit-content' }}
            >
              Toggle Theme
            </Button>
          </Stack>
        </Stack>
      </Card>
    </Card>
  )
}

export default Footer
